import React, { useContext } from "react";
import LangContext from "../../../context/LangContext";
import { Link } from "react-router-dom";

const content = {
  en: {
    title: "Are you planning to Trekking in Nepal?",
  },
};

const AboutNepal = () => {
  const { lang_code } = useContext(LangContext);
  return (
    <div className="container mx-auto px-8 my-10 xl:my-24 ">
      <div className="grid lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-6 prose xl:prose-xl lg:col-start-2">
          <h1 className="">
            ABOUT <span className="text-primary-base">NEPAL</span>
          </h1>
          <section>
            Le Népal, situé au cœur de l'Himalaya, est une destination
            touristique captivante. Connue pour ses sommets majestueux, dont
            l'Everest, la plus haute montagne du monde, le pays offre un paysage
            à couper le souffle et une richesse culturelle unique. Les voyageurs
            peuvent explorer les vallées verdoyantes, les rivières tumultueuses
            et les forêts luxuriantes tout en découvrant les temples anciens,
            les stupas bouddhistes et les palais royaux historiques. <br />
            Les amoureux de la nature ne seront pas déçus lors de leur visite au
            Népal. Le parc national de Chitwan, inscrit au patrimoine mondial de
            l'UNESCO, est un refuge pour de nombreuses espèces animales, dont le
            tigre du Bengale et le rhinocéros unicorne. Les randonneurs et les
            alpinistes peuvent s'attaquer aux sentiers de l'Annapurna ou du
            Langtang, qui offrent des panoramas à couper le souffle et une
            expérience inoubliable.
          </section>
          <Link to={"/about-us"}>
            <button className="border px-4 py-2 rounded-md shadow mt-10">
              Learn More
            </button>
          </Link>
        </div>

        <div className="lg:col-span-4 mt-8 lg:mt-0">
          <img
            src="https://images.pexels.com/photos/4032145/pexels-photo-4032145.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            alt=""
            className="h-full object-cover shadow-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default AboutNepal;
